import { createStore, combineReducers } from 'redux';
import { authenReducer } from './reducers/authenReducer';
import { customerProfileReducer } from './reducers/customerProfileReducer';
import { registerReducer } from './reducers/registerReducer';
import { langReducer } from './reducers/langReducer';
import { globalReducer } from './reducers/globalReducer';
import { mapKeyReducer } from './reducers/mapKeyReducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  authenReducer: authenReducer,
  customerProfileReducer: customerProfileReducer,
  registerReducer: registerReducer,
  langReducer: langReducer,
  globalReducer: globalReducer,
  mapKeyReducer: mapKeyReducer
});

const persistConfig = {
  key: 'loop_store',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };
